<script setup lang="ts">
import { useEnv } from '@library/composables'

const { VITE_APPLICATION_VERSION, VITE_APPLICATION_VERSION_MODE } = useEnv()
</script>

<template>
  <span
    v-if="VITE_APPLICATION_VERSION_MODE"
    class="bf-version"
    :class="VITE_APPLICATION_VERSION_MODE"
  >
    {{ VITE_APPLICATION_VERSION }}
  </span>
</template>

<style lang="scss" scoped>
.bf-version {
  position: fixed;
  bottom: 10px;
  left: 10px;
  z-index: 999999;
  font-size: 12px;
  color: #666;

  &.hidden {
    display: none;
  }
}
</style>
